import type SuperJSON from "superjson";
import { registerPlainDateTransformer } from "./registerPlainDateTransformer";
import { registerPlainYearMonthTransformer } from "./registerPlainYearMonthTransformer";

/**
 * Register SuperJSON custom transformers for temporal types (PlainDate, PlainYearMonth).
 * Domain-specific transformers (Amount, TaxId, LoanAgreement) should be passed
 * as additional arguments to avoid circular workspace dependencies.
 */
export function registerTransformers(
  superjson: typeof SuperJSON,
  ...additionalTransformers: Array<(superjson: typeof SuperJSON) => void>
): void {
  registerPlainDateTransformer(superjson);
  registerPlainYearMonthTransformer(superjson);
  for (const transformer of additionalTransformers) {
    transformer(superjson);
  }
}
